import React from 'react'

export default function HTMLHeaderTemplate(props) {
    const pageSettings = {
        'a4': {
            'width': 794,
            'height': 1123
        },
        'letter': {
            'width': 595,
            'height': 842
        }
    };

    const renderImage = (section) => {
        return props.properties.head.logo.showLogo &&
            props.properties.head.logo.logo !== null ? (
            <div
                style={props.properties.head.logo.style}
                key={props.properties.head.logo.id || 'logo'}
                data-element={props.properties.head.logo.name || 'logo'}
                data-section={section}
                data-path="logo"
                data-index=""
            >
                <div>
                    <img
                        src={props.tempLogo ? props.tempLogo : props.properties.head.logo.logo}
                        style={{
                            width:
                                (props.properties
                                    ? props.properties.head.logo.logoSize
                                    : 100) + "%",
                            pointerEvents: "none",
                        }}
                        alt="Company Logo"
                    />
                </div>
            </div>
        ) : (
            <></>
        );
    };

    const renderElements = (section) => {
        return (
            props.properties &&
            props.properties[section]?.elements &&
            Object.keys(props.properties[section].elements).map((key) => {
                var data = props.properties[section].elements[key];
                if (!data) return null;

                var dStyle = Object.assign({}, data.style || {});
                var font = props.properties[section]?.font || { fontFamily: 'Inter', fontSize: 10 }
                dStyle.color = dStyle.color || props.properties.prop.fontColor;
                dStyle.fontSize = dStyle.fontSize || props.properties.prop.fontSize + "pt";

                dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

                const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || `element-${key}`);

                return (
                    <div
                        key={data.id || key}
                        style={Object.assign(dStyle, font)}
                        id={data.id}
                        data-element={data.name || 'element'}
                        data-section={section}
                        data-path="elements"
                        data-index={dataIndex}
                    >
                        {data.text || ''}
                    </div>
                );
            })
        );
    };

    const renderCompanyElements = () => {
        if (!props.properties.head.companyProps) return null;

        return Object.keys(props.properties.head.companyProps).map((key) => {
            var prop = props.properties.head.companyProps[key];
            if (!prop || !prop.show) return null;

            var dStyle = Object.assign({}, prop.style || {});
            var font = props.properties.head?.font || { fontFamily: 'Inter', fontSize: 10, color: '#000000' }
            dStyle.color = dStyle.color || props.properties.prop.fontColor;
            dStyle.fontSize = dStyle.fontSize || props.properties.prop.fontSize + "pt";
            dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
            dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

            return (
                <div
                    key={key}
                    style={Object.assign(dStyle, font)}
                    id={prop.id}
                    data-element={prop.name || 'company-prop'}
                    data-section={"head"}
                    data-path="companyProps"
                    data-index={prop.data || key}
                >
                    {prop.text || ''}
                </div>
            );
        });
    };

    const renderDocumentTitle = () => {
        var title = props.properties.head.documentTitle;
        if (!title || !title.show) return null;

        var dStyle = Object.assign({}, title.style || {});
        dStyle.color = dStyle.color || props.properties.prop.fontColor;
        dStyle.fontSize = dStyle.fontSize || "20pt";
        dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
        dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

        return (
            <div
                style={dStyle}
                key={title.id || 'doc-title'}
                id={title.id}
                data-element={title.name || 'document-title'}
                data-section={"head"}
                data-path="documentTitle"
                data-index={title.title || 'title'}
            >
                {title.title || 'INVOICE'}
            </div>
        );
    };

    const renderShapes = () => {
        if (!props.properties.head.shapes) return null;

        return Object.keys(props.properties.head.shapes)
            .filter(s => s !== 'border')
            .map((key) => {
                var prop = props.properties.head.shapes[key];
                if (!prop) return null;

                var borderColor = props.properties.head.shapes.border?.color || '#333333FF';
                var borderSize = props.properties.head.shapes.border?.size || 1;
                var bgColor = props.properties.head.shapes.border?.fillColor || '#FFFFFFFF';

                var dStyle = Object.assign({ minWidth: '32px', minHeight: '16px' }, prop.style || {});
                dStyle.border = `${borderSize}px solid ${borderColor}`;
                dStyle.background = bgColor;
                dStyle.left = dStyle.left ? parseInt(dStyle.left) * 0.75 : 0;
                dStyle.width = dStyle.width ? parseInt(dStyle.width) * 0.75 : 32;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;

                return (
                    <div
                        key={key}
                        style={dStyle}
                        id={prop.id}
                        data-element={prop.name || 'shape'}
                        data-section={"head"}
                        data-path="shapes"
                        data-index={prop.data || key}
                    />
                );
            });
    };

    return (
        <div style={{
            height: props.properties.prop.orientation === "landscape"
                ? props.heights.head * 0.01 * pageSettings[props.properties.prop.paperSize]?.width
                : props.heights.head * 0.01 * pageSettings[props.properties.prop.paperSize]?.height
        }}>
            <div>
                {renderElements("head")}
                {renderImage("head")}
                {renderDocumentTitle()}
                {renderCompanyElements()}
                {renderShapes()}
            </div>
        </div>
    );
}